export function getLeftPosition({
  placement,
  targetWidth,
  targetLeft,
  indicatesTargetLeft = 0,
  indicatesTargetWidth = 0,
}) {
  switch (placement) {
    case 'right':
      return targetLeft + targetWidth;
    case 'bottom-start':
      return targetLeft + 8;
    case 'bottom-end':
      return targetLeft + targetWidth - 8;
    case 'bottom':
    default:
      return indicatesTargetLeft ? indicatesTargetLeft + indicatesTargetWidth / 2 : targetLeft + targetWidth / 2;
  }
}

export function getTopPosition({ placement, targetTop, targetHeight }) {
  switch (placement) {
    case 'right':
      return targetTop + targetHeight / 2;
    case 'bottom-start':
    case 'bottom-end':
    case 'bottom':
    default:
      return targetTop + targetHeight;
  }
}

export function getTargetNode(target) {
  if (typeof target === 'string') return document.getElementById(target);
  if (target?.current) return target.current;
  return null;
}
